import RotatingLogo from "./RotatingLogo";

const MainFrameLoader = () => {
    return (
        <div className="mainframe_sidebar_loader">
            <RotatingLogo />
            <div className="loading_mex_cont">
                {Array.from({ length: 7 }).map((_, index) => (
                    <div className="loading_links fade-in" key={index}></div>
                ))}
                <div className="loading_cloud fade-in"></div>
            </div>
        </div>
    )
}

export default MainFrameLoader